import {Languages, DEFAULT_LANGUAGE} from "@/constants/locale";
import browserLang from "browser-lang";
import VueI18n from "vue-i18n";
import messages from "@/locale";
import {getBrowserLanguage} from "@/services/languageUtils";

let i18n: VueI18n|null = null;

export const getI18n = (): VueI18n => {
  if (!i18n) {
    i18n = new VueI18n({
      locale: getBrowserLanguage(), // Set locale from browser by default
      fallbackLocale: DEFAULT_LANGUAGE,
      messages,
    });
  }

  return i18n;
};

